var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "privacypolicy" }, [
    _c(
      "div",
      { staticClass: "main-wrapper" },
      [
        _c("layout-header"),
        _vm._v(" "),
        _c("layout-sidebar"),
        _vm._v(" "),
        _c("div", { staticClass: "page-wrapper" }, [
          _c("div", { staticClass: "content container-fluid" }, [
            _c("div", { staticClass: "page-header" }, [
              _c("div", { staticClass: "row" }, [
                _c("div", { staticClass: "col-sm-12" }, [
                  _c("h3", { staticClass: "page-title" }, [
                    _vm._v("Privacy Policy")
                  ]),
                  _vm._v(" "),
                  _c("ul", { staticClass: "breadcrumb" }, [
                    _c(
                      "li",
                      { staticClass: "breadcrumb-item" },
                      [
                        _c("router-link", { attrs: { to: "/index" } }, [
                          _vm._v("Dashboard")
                        ])
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c("li", { staticClass: "breadcrumb-item active" }, [
                      _vm._v("Privacy Policy")
                    ])
                  ])
                ])
              ])
            ]),
            _vm._v(" "),
            _vm._m(0)
          ])
        ])
      ],
      1
    )
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "row" }, [
      _c("div", { staticClass: "col-sm-12" }, [
        _c("p", [
          _vm._v(
            "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Pellentesque vel sodales mauris.\n                            Nunc accumsan mi massa, ut maximus magna ultricies et:"
          )
        ]),
        _vm._v(" "),
        _c("ol", [
          _c("li", [
            _vm._v(
              "Integer quam odio, ullamcorper id diam in, accumsan convallis libero. Duis at\n                                lacinia urna."
            )
          ]),
          _vm._v(" "),
          _c("li", [
            _vm._v(
              "Mauris eget turpis sit amet purus pulvinar facilisis at sed lacus."
            )
          ]),
          _vm._v(" "),
          _c("li", [
            _vm._v(
              "Quisque malesuada volutpat orci, accumsan scelerisque lorem pulvinar vitae."
            )
          ]),
          _vm._v(" "),
          _c("li", [
            _vm._v(
              "Vestibulum sit amet sem aliquam, vestibulum nisi sed, sodales libero."
            )
          ])
        ]),
        _vm._v(" "),
        _c("h4", [
          _vm._v("Aenean accumsan aliquam justo, et rhoncus est ullamcorper at")
        ]),
        _vm._v(" "),
        _c("p", [
          _vm._v(
            "Donec posuere dictum enim, vel sollicitudin orci tincidunt ac. Maecenas mattis ex eu elit\n                            tincidunt egestas. Vivamus posuere nunc vel metus bibendum varius. Vestibulum suscipit\n                            lacinia eros a aliquam. Sed dapibus arcu eget egestas hendrerit."
          )
        ]),
        _vm._v(" "),
        _c("p", [
          _vm._v(
            "Vivamus consectetur metus at nulla efficitur mattis. Aenean egestas eu odio vestibulum\n                            vestibulum. Duis nulla lectus, lacinia vitae nibh vitae, sagittis interdum lacus. Mauris\n                            lacinia leo odio, eget finibus lectus pharetra ut. Nullam in semper enim, id gravida\n                            nulla."
          )
        ]),
        _vm._v(" "),
        _c("p", [
          _vm._v(
            "Fusce gravida auctor justo, vel lobortis sem efficitur id. Cras eu eros vitae justo\n                            dictum tempor."
          )
        ]),
        _vm._v(" "),
        _c("h4", [
          _vm._v("Etiam sed fermentum lectus. Quisque vitae ipsum libero")
        ]),
        _vm._v(" "),
        _c("p", [
          _vm._v(
            "Phasellus sit amet vehicula arcu. Etiam pulvinar dui libero, vitae fringilla nulla\n                            convallis in. Fusce sagittis cursus nisl, at consectetur elit vestibulum vestibulum:"
          )
        ]),
        _vm._v(" "),
        _c("ul", [
          _c("li", [_vm._v("Nunc pulvinar efficitur interdum.")]),
          _vm._v(" "),
          _c("li", [_vm._v("Donec feugiat feugiat pulvinar.")]),
          _vm._v(" "),
          _c("li", [
            _vm._v(
              "Suspendisse eu risus feugiat, pellentesque arcu eu, molestie lorem. "
            )
          ]),
          _vm._v(" "),
          _c("li", [
            _vm._v("Duis non leo commodo, euismod ipsum a, feugiat libero.")
          ])
        ]),
        _vm._v(" "),
        _c("h4", [_vm._v("pulvinar")]),
        _vm._v(" "),
        _c("p", [
          _vm._v(
            "Sed sollicitudin, diam nec tristique tincidunt, nulla ligula facilisis nunc, non\n                            condimentum tortor leo id ex."
          )
        ]),
        _vm._v(" "),
        _c("p", [
          _vm._v(
            "Vivamus consectetur metus at nulla efficitur mattis. Aenean egestas eu odio vestibulum\n                            vestibulum. Duis nulla lectus, lacinia vitae nibh vitae, sagittis interdum lacus. Mauris\n                            lacinia leo odio, eget finibus lectus pharetra ut. Nullam in semper enim, id gravida\n                            nulla."
          )
        ]),
        _vm._v(" "),
        _c("p", [
          _vm._v(
            "Donec posuere dictum enim, vel sollicitudin orci tincidunt ac. Maecenas mattis ex eu elit\n                            tincidunt egestas. Vivamus posuere nunc vel metus bibendum varius. Vestibulum suscipit\n                            lacinia eros a aliquam. Sed dapibus arcu eget egestas hendrerit.Donec posuere dictum\n                            enim, vel sollicitudin orci tincidunt ac. Maecenas mattis ex eu elit tincidunt egestas.\n                            Vivamus posuere nunc vel metus bibendum varius. Vestibulum suscipit lacinia eros a\n                            aliquam. Sed dapibus arcu eget egestas hendrerit."
          )
        ]),
        _vm._v(" "),
        _c("h4", [_vm._v("efficitur")]),
        _vm._v(" "),
        _c("p", [
          _vm._v(
            "Fusce gravida auctor justo, vel lobortis sem efficitur id. Cras eu eros vitae justo\n                            dictum tempor."
          )
        ]),
        _vm._v(" "),
        _c("p", [
          _c("strong", [
            _vm._v(
              "Vivamus posuere nunc vel metus bibendum varius. Vestibulum suscipit lacinia eros\n                                a aliquam. Sed dapibus arcu eget egestas hendrerit.Donec posuere dictum enim, vel\n                                sollicitudin orci tincidunt ac."
            )
          ])
        ])
      ])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-fb1c4c4c", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-fb1c4c4c","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/privacypolicy.vue
// module id = null
// module chunks = 